module.exports = "https://static.im-cdn.com/mjc/storefront/Esteem/static/media/FooterPinterest.72367cc8.svg";